import { parseISO } from 'date-fns';
import { DATE_FORMAT_DD_MM } from 'utils/constants/date';
import { formatDate, TODAY_START_OF_DAY } from 'utils/date';
import { FIRST_CAMPAIGN_AUCTION_PROMO } from 'utils/promoBonus';

import { selectAvailablePromos } from 'store/autoReducers';
import { useSelector } from 'store/utils';

export const useAvailableFirstCampaignAuctionPromo = (): {
    isPromoAvailable: boolean;
    promoEndDate?: string;
    maxBonusAmount?: number;
    promoSumPercent?: number;
    termsLink?: string;
} => {
    const availablePromos = useSelector(selectAvailablePromos);

    const firstCampaignAuctionPromo = availablePromos ? availablePromos[FIRST_CAMPAIGN_AUCTION_PROMO] : null;

    const endDate = firstCampaignAuctionPromo?.endDate;
    const promoEndDate = endDate ? parseISO(endDate) : null;
    const promoSumPercent = firstCampaignAuctionPromo?.sumPercent;

    return {
        isPromoAvailable: Boolean(firstCampaignAuctionPromo && promoEndDate && promoEndDate >= TODAY_START_OF_DAY),
        promoEndDate: promoEndDate ? formatDate(promoEndDate, DATE_FORMAT_DD_MM) : undefined,
        promoSumPercent,
        maxBonusAmount: firstCampaignAuctionPromo?.maxBonusAmount,
        termsLink: firstCampaignAuctionPromo?.termsLink,
    };
};
